module.exports = __webpack_public_path__ + "img/fabric-slide-3-xxl.7af5d85.webp";